<template>
  <div>
    <div class="form-group form-group-default required form-multiselect"
         :class="{ 'form-group-ie': isIE }">
      <universal-multiselect :label="$t('models.user.services')"
                             fieldLabel="name"
                             fieldTrackBy="id"
                             :initialValues="user.services"
                             :availableValues="availableServicesWithAllOption"
                             :placeholder="$t('multiselect.placeholder')"
                             :validationRules="servicesValidationRules"
                             :validationName="fieldName"
                             :validationTranslation="$t('models.user.services')"
                             :disableCondition="disabledConditions"
                             @change="onChange($event)" />
    </div>

    <transition name="slide-fade">
      <label v-show="errors.has(fieldName)"
             id="services-error"
             class="error"
             :for="fieldName">
        {{ errors.first(fieldName) }}
      </label>
    </transition>
  </div>
</template>

<script>
import UniversalMultiselect from '@/components/form/UniversalMultiselect'

const { detect } = require('detect-browser');

export default {
  name: 'ServicesField',
  inject: ['$validator'],
  props: {
    availableServices: Array,
    disabledConditions: Boolean,
    isManager: Boolean,
    user: Object,
    fieldNameAddition: { type: [String, Number], default: null },
    hasRealHubs: { type: Boolean, default: false },
  },
  components: {
    UniversalMultiselect
  },
  methods: {
    onChange(values) {
      if (values.some(option => option.id === null)) {
        this.$emit('change', [...this.availableServices])
      } else {
        this.$emit('change', values)
      }
    }
  },
  computed: {
    isIE() {
      if (detect()) {
        return detect().name == "ie"
      }
    },
    availableServicesWithAllOption() {
      var servicesOptionsWithSelectAll = [...this.availableServices]

      if(servicesOptionsWithSelectAll.length > 1) {
        servicesOptionsWithSelectAll.unshift({
          name: this.$t("global.select_all"),
          id: null
        })
      }
      return servicesOptionsWithSelectAll
    },
    servicesValidationRules(){
      return (this.isInternal && !this.isManager) ? `required|affiliated:${this.isAffiliatedServiceInServicesList}` : 'required'
    },
    isInternal(){
      return this.user.resource_type == 'intern'
    },
    isAffiliatedServiceInServicesList(){
      if (this.user.services && this.user.affiliated_service) {
        return this.user.services.map(service => service.id).includes(this.user.affiliated_service.id)
      }
      return false
    },
    fieldName() {
      return this.fieldNameAddition ? `services_${this.fieldNameAddition}` : 'services';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/form/ServicesField.vue